<template>
  <div>
    <div
      class="merge-search-presentation-wrapper flex items-center"
      :class="{disabled: isDisabled, 'has-text': searchValue}"
    >
      <aha-input
        :placeholder="getTemplateSearchPlaceHolder"
        class="cursor-pointer font-normal text-base search__input"
        v-model="searchValue"
        @input="_onSearchInput"
        ref="search"
        :readonly="readOnlyIfInMyProfile"
        @click="removeDisabled($event)"
        @focusout="unFocusSearch()"
        autocomplete="new-password"
      >
        <template #append>
          <aha-icon
            name="search"
            class="search__icon absolute top-0 flex items-center h-10 text-base-60 left-2"
            width="16"
            height="16"
            viewBox="0 0 24 24"
          />
          <aha-icon
            name="close"
            class="clear__icon absolute top-0 flex items-center h-10
            text-base-60 right-2 hidden "
            width="16"
            height="16"
            viewBox="0 0 24 24"
            @click="_onClickClearSearch"
          />
        </template>
      </aha-input>
      <span
        class="pr-4 cursor-pointer lg:hidden"
        @click="focusSearch()"
      >
        <aha-icon
          name="search"
          class="trigger_search_icon"
        />
      </span>
    </div>
  </div>
</template>
<script>
import debounce from 'debounce'
import { mapState, mapActions } from 'vuex'
import utils from '@/util'
import constants from '@/constant'
import SearchApi from '@/api/search'
import Config from '@/config'

export default {
  data() {
    return {
      searchValue: '',
    }
  },
  computed: {
    ...mapState({
      searchBy: (state) => state.search.searchBy,
    }),
    isDisabled() {
      return this.$route.name === 'Upgrade' || this.$route.name === 'UserCancelSub'
    },
    isEURegion() {
      return Config.region === constants.euRegion
    },
    readOnlyIfInMyProfile() {
      if (this.$route.name === 'UserProfile') {
        return true
      }
      return false
    },
    getTemplateSearchPlaceHolder() {
      return this.$i18nPresenter.t('Search presentations..')
    },
  },
  watch: {
    $route(to) {
      if (to.name === 'Presentations' || to.name === 'TemplateLibrary') {
        if (this.$route.query.q && this.$route.query.q.length > 1) {
          this.searchValue = this.$route.query.q
        } else if (!this.$route.query.q ||
            this.$route.query.from === 'requestTemplate' ||
            this.$route.query.from === 'leftSidebar') {
          this.searchValue = ''
        }
      } else {
        this.clearSearch()
      }
    },
  },
  mounted() {
    if (this.$route.query.q && this.$route.query.q.length > 1) {
      this.searchValue = this.$route.query.q
    }
    this.setSelectedSearchByAction('presentation')
  },
  methods: {
    ...mapActions([
      'setSelectedSearchByAction',
      'setTotalTemplateAction',
      'setTotalPresentationAction',
    ]),
    _onSearchInput: debounce(async function onSearchInputDebounce() {
      // EU: Just search Presentation only, not call getTotalResult api
      if (this.isEURegion) {
        this.searchPresentation()
      } else {
      // Non EU: normal search with both presentaion + template + switchtabsearch + call totalAPI
        this.searchPresentation()
        if (this.searchValue) {
          utils.trackGA4AndMixpanel('search', {
            search_term: this.searchValue,
          })
        }
      }
    }, 400),

    clearSearch() {
      this.searchValue = ''
      if (!this.euRegion) {
        this.setTotalTemplateAction(0)
        this.setTotalPresentationAction(0)
      }
    },

    searchPresentation() {
      const query = {}
      const text = this.searchValue.trim()
      if (text.length !== 1) {
        if (text.length > 1) {
          query.q = this.searchValue
        }
        this.gaTrackingWhenSearching()
        this.$router.push({ name: 'Presentations', query })
      }
    },

    async searchTemplate() {
      const query = {}
      const text = this.searchValue.trim()
      if (text.length !== 1) {
        if (!text.length) {
          query.from = 'clearSearch'
        } else if (text.length > 1) {
          query.q = this.searchValue
          query.from = 'searchBar'
        }
        this.gaTrackingWhenSearching()
        this.$router.push({ name: 'TemplateLibrary', query })
      }
    },

    async getTotalResult() {
      const text = this.searchValue.trim()
      if (text.length === 0 || text.length === 1) {
        this.setTotalTemplateAction(0)
        this.setTotalPresentationAction(0)
        return {
          totalTemplates: 0,
          totalPresentations: 0,
        }
      }
      if (text.length > 1) {
        const payload = {
          q: text,
        }
        const resp = await SearchApi.getTotalResult(payload)
        const { totalTemplates, totalPresentations } = resp.body
        this.setTotalTemplateAction(totalTemplates)
        this.setTotalPresentationAction(totalPresentations)
        return {
          totalTemplates,
          totalPresentations,
        }
      }
      return {
        totalTemplates: 0,
        totalPresentations: 0,
      }
    },
    _onClickClearSearch() {
      this.clearSearch()
      this.searchPresentation()
    },

    gaTrackingWhenSearching() {
      let eventCategory = ''
      switch (this.$route.name) {
        case 'Presentations':
          eventCategory = `${constants.eventCategories.PRESENTATION_LIST} > Search template`
          break
        case 'TemplateLibrary':
          eventCategory = `${constants.eventCategories.TEMPLATE_LIBRARY} > Search template`
          break
        case 'SharedWithMe':
          eventCategory = `${constants.eventCategories.SHARE_WITH_ME} > Search template`
          break
        case 'UserPlan':
          eventCategory = `${constants.eventCategories.MY_PLAN} > Search template`
          break
        case 'Referral':
          eventCategory = `${constants.eventCategories.REFER_FRIEND} > Search template`
          break
        case 'WhatsNew':
          eventCategory = `${constants.eventCategories.WHATSNEW} > Search template`
          break
        default:
          eventCategory = ''
          break
      }
      utils.mixpanelTracking(eventCategory, 'Search Presentation', this.searchValue, 'Template')
    },
    focusSearch() {
      const input = document.querySelector('.search__input')
      const ahaslidesLogo = document.querySelector('.logo-merge-search-wrapper')
      input.style.visibility = 'visible'
      input.firstChild.focus()
      ahaslidesLogo.style.display = 'none'
    },
    unFocusSearch() {
      const ahaslidesLogo = document.querySelector('.logo-merge-search-wrapper')
      ahaslidesLogo.style.display = 'block'
      if (window.outerWidth < 1024) {
        const input = document.querySelector('.search__input')
        input.style.visibility = 'hidden'
      }
    },
    removeDisabled(event) {
      // autofill password error, hot-fix by read-only, detect click to remove readonly
      event.preventDefault()
      if (event.target.getAttribute('readonly') == 'readonly') {
        event.target.removeAttribute('readonly')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.merge-search-presentation-wrapper {
  margin-left: 4px;
  &.disabled {
    @apply hidden;
  }
}
.merge-search-presentation-wrapper input {
  text-indent: 1.5rem !important;
}

::v-deep .search__input input {
  padding-right: 1.75rem;
  padding-left: 2rem;
}

.search__icon {
  color: black;
}
.search__input {
  @apply invisible w-full lg:w-4/5 lg:visible lg:ml-28 lg:max-w-sm;
}
.search__input:hover > .search__icon {
  @apply text-primary-90;
}
.search__input:focus-within > .search__icon {
  @apply text-primary-90;
}
.clear__icon:hover {
  @apply text-primary-90;
}
.clear__icon {
  display: none;
}
.merge-search-presentation-wrapper:focus-within {
  .trigger_search_icon {
    @apply hidden;
  }
}
.merge-search-presentation-wrapper.has-text {
  .clear__icon {
    display: hidden;
    @media (min-width: 1024px) {
      display: block;
    }
  }
}
</style>
